import type { InputHTMLAttributes } from "react";
import { useFieldControl } from "./Field";
import { cx } from "./utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Render the smaller, denser variant. */
  dense?: boolean;
}

/** Single-line text input. Picks up id/aria wiring from an enclosing `Field`. */
export function Input({ className, dense, ...rest }: InputProps) {
  const field = useFieldControl();
  return (
    <input className={cx("xz-input", dense && "xz-input--dense", className)} {...field} {...rest} />
  );
}
